import axiosMultipartClient from "api/axiosMultipartClient";

export const createResumeRevamp = async (formData: FormData) => {
  try {
    const response = await axiosMultipartClient.post(
      "/api/resume-revamp",
      formData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
